package com.eladfinish.bible.contest.screens.americanQuestions.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsPressedAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.navigation.NavController
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimary
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.common.gender.HebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.copied_to_clipboard
import com.eladfinish.bible.contest.darkGreen
import com.eladfinish.bible.contest.darkRed
import com.eladfinish.bible.contest.di.getKoinInstance
import com.eladfinish.bible.contest.extensions.makeBoldByAsterisksAnnotated
import com.eladfinish.bible.contest.highlight
import com.eladfinish.bible.contest.internet_is_required
import com.eladfinish.bible.contest.navigation.MultipleChoiceQuestionsScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.screenKey
import com.eladfinish.bible.contest.new_test
import com.eladfinish.bible.contest.no_questions_for_this_mikud
import com.eladfinish.bible.contest.parchment_verse
import com.eladfinish.bible.contest.platform.audio.SoundEffect
import com.eladfinish.bible.contest.platform.audio.SoundService
import com.eladfinish.bible.contest.platform.haptics.HapticService
import com.eladfinish.bible.contest.questions_are_over
import com.eladfinish.bible.contest.screens.americanQuestions.AmericanQuestionsAction
import com.eladfinish.bible.contest.screens.americanQuestions.AmericanQuestionsEffect
import com.eladfinish.bible.contest.screens.americanQuestions.AmericanQuestionsState
import com.eladfinish.bible.contest.screens.americanQuestions.AmericanQuestionsStore
import com.eladfinish.bible.contest.screens.americanQuestions.QuestionDisplayState
import com.eladfinish.bible.contest.screens.americanQuestions.menu.MultipleChoiceToolbarId
import com.eladfinish.bible.contest.screens.americanQuestions.model.QuestionResult
import com.eladfinish.bible.contest.screens.americanQuestions.ui.dialogs.AmericanQuestionsDialogs
import com.eladfinish.bible.contest.screens.randomVerse.ui.AnimationState
import com.eladfinish.bible.contest.screens.settings.ui.components.ComponentNavigationDestination
import com.eladfinish.bible.contest.screens.settings.ui.components.model.SubSettingsComponentType
import com.eladfinish.bible.contest.screens.settings.ui.screens.KEY_AMERICAN_QUESTIONS_REFRESH
import com.eladfinish.bible.contest.strokeColor
import com.eladfinish.bible.contest.ui.animations.rememberBounceAnimation
import com.eladfinish.bible.contest.ui.animations.rememberScaleAnimation
import com.eladfinish.bible.contest.ui.common.PreviewTheme
import com.eladfinish.bible.contest.ui.common.SetScreenIsLoading
import com.eladfinish.bible.contest.ui.components.ParchmentView
import com.eladfinish.bible.contest.ui.components.toolbar.UpdateToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.verticalScrollWithScrollbar
import com.eladfinish.bible.contest.ui.extensions.LocalNavigationBarInset
import com.eladfinish.bible.contest.ui.layout.isShortWideWindow
import com.eladfinish.bible.contest.ui.layout.readableWidth
import com.eladfinish.bible.contest.ui.menus.actions.MultipleChoiceQuestionsToolbarAction
import com.eladfinish.bible.contest.ui.menus.viewModels.ToolbarActionBusViewModel
import com.eladfinish.bible.contest.ui.text.toAnnotatedWithUnderscorePlaceholders
import com.eladfinish.bible.contest.your_grade
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toImmutableList
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.Flow
import org.koin.compose.viewmodel.koinViewModel
import kotlin.math.roundToInt
import kotlin.time.Duration.Companion.milliseconds

private const val DELAY_BETWEEN_QUESTIONS = 800L
private const val COUNTDOWN_SECONDS = 15

@Composable
fun AmericanQuestionsScreen(
    fromPairMatching: Boolean = false,
    toolbarActionBus: ToolbarActionBusViewModel,
    navController: NavController,
    openSettings: (ComponentNavigationDestination) -> Unit,
    showToastStringResource: (StringResource) -> Unit,
    store: AmericanQuestionsStore = koinViewModel(),
    soundService: SoundService = getKoinInstance(),
    hapticService: HapticService = getKoinInstance(),
) {
    val state by store.observeState().collectAsState()
    val currentOpenSettings by rememberUpdatedState(openSettings)
    val currentShowToast by rememberUpdatedState(showToastStringResource)

    LaunchedEffect(fromPairMatching) {
        if (fromPairMatching) store.dispatch(AmericanQuestionsAction.FetchFromPairMatching)
    }

    // Re-read settings when returning from AmericanQuestionsSettingsScreen
    ObserveSettingsRefresh(
        navController = navController,
        onRefresh = { store.dispatch(AmericanQuestionsAction.SettingsChanged) },
    )

    AmericanQuestionsToolbarBindings(
        toolbarActionBus = toolbarActionBus,
        onFiftyFifty = { store.dispatch(AmericanQuestionsAction.FiftyFiftyClicked) },
        onHelp = { store.dispatch(AmericanQuestionsAction.HelpClicked) },
        onRefresh = { store.dispatch(AmericanQuestionsAction.RefreshClicked) },
        onSettings = { store.dispatch(AmericanQuestionsAction.SettingsClicked) },
    )

    // Disable the 50:50 button once used or when game is over — mirrors the legacy toggleFiftyFifty()
    val fiftyFiftyEnabled = !state.usedFiftyFifty && !state.isGameOver
    UpdateToolbarConfiguration<MultipleChoiceToolbarId>(
        update = {
            copy(
                actions = actions.map { action ->
                    if (action is ToolbarActionConfig.TextActionRes &&
                        action.id == MultipleChoiceToolbarId.FIFTY_FIFTY
                    ) {
                        action.copy(enabled = fiftyFiftyEnabled)
                    } else {
                        action
                    }
                }.toImmutableList()
            )
        },
        fiftyFiftyEnabled,
    )

    AmericanQuestionsSideEffectsCollector(
        effects = store.observeSideEffect(),
        onPlayCorrectSound = { soundService.playIfAllowed(SoundEffect.CORRECT) },
        onPlayWrongSound = { soundService.playIfAllowed(SoundEffect.WRONG) },
        onPlayTimeUpSound = { soundService.playIfAllowed(SoundEffect.TIME_UP) },
        onHaptic = { isCorrect -> hapticService.vibrateIfAllowed(milliseconds = if (isCorrect) 320L else 80L) },
        onOpenSettings = {
            currentOpenSettings(ComponentNavigationDestination(type = SubSettingsComponentType.AMERICAN_QUESTIONS_SETTINGS))
        },
        onCopiedToClipboard = { currentShowToast(SharedRes.strings.copied_to_clipboard) },
        onNoInternet = { currentShowToast(SharedRes.strings.internet_is_required) },
    )

    AmericanQuestionsContent(
        state = state,
        hebrewGender = state.hebrewGender,
        onAnswer = { store.dispatch(AmericanQuestionsAction.AnswerSelected(it)) },
        onAdvance = { store.dispatch(AmericanQuestionsAction.AdvanceQuestion) },
        onNewGame = { store.dispatch(AmericanQuestionsAction.NewGame) },
        onNumberClick = { if (state.isGameOver) store.dispatch(AmericanQuestionsAction.ShowHistory(it)) },
        onQuestionLongClick = { text -> store.dispatch(AmericanQuestionsAction.CopyQuestion(text)) },
    )

    AmericanQuestionsDialogs(dialogState = state.dialogState, onAction = store::dispatch)

    SetScreenIsLoading(state.isLoading)
}

// ── Settings refresh observer ─────────────────────────────────────────────────

@Composable
private fun ObserveSettingsRefresh(
    navController: NavController,
    onRefresh: () -> Unit,
) {
    val backStackEntry = navController.currentBackStackEntry
    val refreshFlow = remember(backStackEntry) {
        backStackEntry
            ?.savedStateHandle
            ?.getStateFlow(KEY_AMERICAN_QUESTIONS_REFRESH, initialValue = false)
    }
    val currentOnRefresh by rememberUpdatedState(onRefresh)

    LaunchedEffect(refreshFlow) {
        refreshFlow?.collect { shouldRefresh ->
            if (!shouldRefresh) return@collect
            backStackEntry?.savedStateHandle?.set(KEY_AMERICAN_QUESTIONS_REFRESH, false)
            currentOnRefresh()
        }
    }
}

// ── Toolbar bindings ──────────────────────────────────────────────────────────

@Composable
private fun AmericanQuestionsToolbarBindings(
    toolbarActionBus: ToolbarActionBusViewModel,
    onFiftyFifty: () -> Unit,
    onHelp: () -> Unit,
    onRefresh: () -> Unit,
    onSettings: () -> Unit,
) {
    val screenKey = MultipleChoiceQuestionsScreenNavigationDestination::class.screenKey
    val currentOnFiftyFifty by rememberUpdatedState(onFiftyFifty)
    val currentOnHelp by rememberUpdatedState(onHelp)
    val currentOnRefresh by rememberUpdatedState(onRefresh)
    val currentOnSettings by rememberUpdatedState(onSettings)

    LaunchedEffect(screenKey) {
        toolbarActionBus.setActiveScreenKey(screenKey)
        toolbarActionBus.events.collect { event ->
            if (event.screenKey != screenKey) return@collect
            when (event.action as? MultipleChoiceQuestionsToolbarAction ?: return@collect) {
                MultipleChoiceQuestionsToolbarAction.FiftyFifty -> currentOnFiftyFifty()
                MultipleChoiceQuestionsToolbarAction.Help -> currentOnHelp()
                MultipleChoiceQuestionsToolbarAction.Refresh -> currentOnRefresh()
                MultipleChoiceQuestionsToolbarAction.Settings -> currentOnSettings()
            }
        }
    }
}

// ── Side-effects collector ────────────────────────────────────────────────────

@Composable
private fun AmericanQuestionsSideEffectsCollector(
    effects: Flow<AmericanQuestionsEffect>,
    onPlayCorrectSound: () -> Unit,
    onPlayWrongSound: () -> Unit,
    onPlayTimeUpSound: () -> Unit,
    onHaptic: (Boolean) -> Unit,
    onOpenSettings: () -> Unit,
    onCopiedToClipboard: () -> Unit,
    onNoInternet: () -> Unit,
) {
    val currentOnCorrect by rememberUpdatedState(onPlayCorrectSound)
    val currentOnWrong by rememberUpdatedState(onPlayWrongSound)
    val currentOnTimeUp by rememberUpdatedState(onPlayTimeUpSound)
    val currentOnHaptic by rememberUpdatedState(onHaptic)
    val currentOnOpenSettings by rememberUpdatedState(onOpenSettings)
    val currentOnCopied by rememberUpdatedState(onCopiedToClipboard)
    val currentOnNoInternet by rememberUpdatedState(onNoInternet)

    LaunchedEffect(Unit) {
        effects.collect { effect ->
            when (effect) {
                is AmericanQuestionsEffect.AnswerResult -> when {
                    effect.isTimerExpired -> currentOnTimeUp()
                    effect.isCorrect -> {
                        currentOnCorrect()
                        currentOnHaptic(true)
                    }

                    else -> {
                        currentOnWrong()
                        currentOnHaptic(false)
                    }
                }

                AmericanQuestionsEffect.OpenRandomVerseSettings -> currentOnOpenSettings()
                AmericanQuestionsEffect.CopiedToClipboard -> currentOnCopied()
                AmericanQuestionsEffect.NoInternet -> currentOnNoInternet()
                is AmericanQuestionsEffect.SetFiftyFiftyEnabled -> { /* toolbar state managed via UpdateToolbarConfiguration */
                }
            }
        }
    }
}

// ── Answer feedback ───────────────────────────────────────────────────────────

private sealed interface AnswerFeedbackState {
    data object None : AnswerFeedbackState
    data class Showing(val correctIndex: Int, val userIndex: Int) : AnswerFeedbackState
}

// ── Main content ──────────────────────────────────────────────────────────────

@Composable
private fun AmericanQuestionsContent(
    state: AmericanQuestionsState,
    hebrewGender: HebrewGender,
    onAnswer: (answerIndex: Int) -> Unit,
    onAdvance: () -> Unit,
    onNewGame: () -> Unit,
    onNumberClick: (Int) -> Unit,
    onQuestionLongClick: (text: String) -> Unit,
) {
    // Read from the store, and the time left is saved per question: a rotation mid-question or
    // during the feedback continues the same question, and cannot answer it a second time.
    val isAnsweredThisQuestion = state.isCurrentQuestionAnswered
    val currentIsAnswered by rememberUpdatedState(isAnsweredThisQuestion)
    var countdownSeconds by rememberSaveable(state.currentQuestionIndex) { mutableIntStateOf(COUNTDOWN_SECONDS) }
    val answerFeedback = if (isAnsweredThisQuestion) {
        AnswerFeedbackState.Showing(
            correctIndex = state.correctAnswerIndex,
            userIndex = state.displayedDisplayState?.userAnswerIndex ?: -1,
        )
    } else {
        AnswerFeedbackState.None
    }

    // Countdown timer
    LaunchedEffect(state.currentQuestionIndex) {
        if (state.currentQuestionIndex < 0 || state.isGameOver || !state.enableCountdown) return@LaunchedEffect
        while (countdownSeconds > 0) {
            delay(1000.milliseconds)
            if (currentIsAnswered) return@LaunchedEffect
            countdownSeconds -= 1
        }
        if (!currentIsAnswered) onAnswer(-1)
    }

    // Advance after feedback delay
    LaunchedEffect(state.currentQuestionIndex, isAnsweredThisQuestion) {
        if (!isAnsweredThisQuestion || state.isGameOver) return@LaunchedEffect
        delay(DELAY_BETWEEN_QUESTIONS.milliseconds)
        onAdvance()
    }

    val green = colorResource(SharedRes.colors.darkGreen)
    val red = colorResource(SharedRes.colors.darkRed)
    val strokeColor = colorResource(SharedRes.colors.strokeColor)
    val primaryColor = colorResource(SharedRes.colors.colorPrimary)

    val isShortWindow = isShortWideWindow()

    Column(
        modifier = Modifier
            .fillMaxSize()
            // A phone in landscape puts the answers in two columns, so it can use its whole width.
            .then(if (isShortWindow) Modifier else Modifier.readableWidth())
            .padding(start = 12.dp, top = 12.dp, end = 12.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        // ── Fixed top section ─────────────────────────────────────────────────
        QuestionNumbersRow(
            totalSlots = state.numberOfQuestions,
            availableCount = state.numberOfQuestionsInFile,
            currentQuestionIndex = state.currentQuestionIndex,
            questionResults = state.questionResults,
            isGameOver = state.isGameOver,
            onNumberClick = onNumberClick,
            green = green,
            red = red,
            strokeColor = strokeColor,
        )

        if (state.isGameOver) {
            Spacer(modifier = Modifier.height(8.dp))
            StyledButton(text = stringResource(SharedRes.strings.new_test), onClick = onNewGame)
        }

        // ── Lower section: stuck to bottom, scrollable when content overflows ──
        // BoxWithConstraints measures the available height.
        // A top Spacer sized to (available − content) pushes content to the bottom.
        // When content is taller than the available space the Spacer shrinks to 0
        // and verticalScroll lets the user reveal all buttons by scrolling down.
        BoxWithConstraints(
            modifier = Modifier
                .weight(1f)
                .fillMaxWidth(),
        ) {
            val availableHeightPx = constraints.maxHeight
            val density = LocalDensity.current
            var contentHeightPx by remember { mutableIntStateOf(availableHeightPx) }
            // The screen runs behind the navigation bar: keep the buttons above it (plus the
            // outer column's 12dp margin, which it no longer has at the bottom).
            val navigationBarInset = LocalNavigationBarInset.current + 12.dp
            val navigationBarInsetPx = with(density) { navigationBarInset.roundToPx() }

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .verticalScrollWithScrollbar(),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                // Top spacer that pushes content to the bottom
                Spacer(
                    modifier = Modifier.height(
                        with(density) {
                            (availableHeightPx - contentHeightPx - navigationBarInsetPx).coerceAtLeast(0).toDp()
                        }
                    )
                )

                // Inner column measured so the top spacer can be sized correctly
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .onSizeChanged { contentHeightPx = it.height },
                    horizontalAlignment = Alignment.CenterHorizontally,
                ) {
                    val displayedQuestion = state.displayedQuestion
                    val displayedDisplayState = state.displayedDisplayState

                    // Pure game-over: grade parchment + instruction buttons
                    if (state.isGameOver && state.displayedQuestionIndex == -1) {
                        val gradeMessage = when {
                            state.numberOfQuestionsInFile == 0 ->
                                stringResource(SharedRes.strings.no_questions_for_this_mikud)

                            state.numberOfAskedQuestions == 0 ->
                                stringResource(SharedRes.strings.questions_are_over)

                            else -> {
                                val grade = (state.numberOfCorrectAnswers * 100.0 / state.numberOfAskedQuestions).roundToInt()
                                "${stringResource(SharedRes.strings.your_grade)}: $grade"
                            }
                        }

                        val bounceModifier = rememberBounceAnimation(trigger = true)
                        GameOverParchmentView(
                            message = gradeMessage,
                            textColor = primaryColor,
                            modifier = Modifier.fillMaxWidth().then(bounceModifier),
                        )
                        Spacer(modifier = Modifier.height(8.dp))
                        GameOverInstructionButtons(
                            hebrewGender = hebrewGender,
                            green = green,
                            red = red,
                        )
                    }

                    // Active question OR history review: parchment + answer buttons
                    if (displayedQuestion != null && displayedDisplayState != null) {
                        val isLiveQuestion = !state.isGameOver && state.displayedQuestionIndex == state.currentQuestionIndex

                        var animationState by remember { mutableStateOf(AnimationState.IDLE) }
                        LaunchedEffect(state.displayedQuestionIndex) {
                            if (state.isGameOver) return@LaunchedEffect
                            animationState = if (animationState == AnimationState.IDLE) AnimationState.OFF else AnimationState.RUNNING
                        }
                        val scaleModifier = rememberScaleAnimation(
                            animationState = animationState,
                            resetScaleAnimation = { animationState = AnimationState.IDLE },
                        )

                        ParchmentView(
                            modifier = Modifier.fillMaxWidth().then(scaleModifier),
                            pasukText = displayedQuestion.question.toAnnotatedWithUnderscorePlaceholders()
                                .makeBoldByAsterisksAnnotated(),
                            onVerseClick = {},
                            onVerseLongClick = { onQuestionLongClick(displayedQuestion.question) },
                        )
                        Spacer(modifier = Modifier.height(8.dp))

                        val optionColors = buildOptionColors(
                            displayState = displayedDisplayState,
                            answerFeedback = answerFeedback,
                            isLiveQuestion = isLiveQuestion,
                            green = green,
                            red = red,
                        )

                        val answerButton: @Composable (index: Int, optionText: String) -> Unit = { index, optionText ->
                            AnswerButton(
                                letter = listOf("א", "ב", "ג", "ד")[index],
                                text = optionText,
                                feedbackColor = optionColors[index],
                                enabled = isLiveQuestion && !isAnsweredThisQuestion && !state.disabledOptionIndices.contains(index),
                                onClick = {
                                    if (!isAnsweredThisQuestion && isLiveQuestion) {
                                        onAnswer(index)
                                    }
                                },
                            )
                        }
                        val options = displayedDisplayState.shuffledOptions.withIndex().toList()
                        Column(modifier = Modifier.fillMaxWidth()) {
                            options.chunked(if (isShortWindow) 2 else 1).forEach { rowOptions ->
                                Row(modifier = Modifier.fillMaxWidth()) {
                                    rowOptions.forEach { (index, optionText) ->
                                        Box(modifier = Modifier.weight(1f)) {
                                            answerButton(index, optionText)
                                        }
                                    }
                                }
                            }
                        }

                        if (state.enableCountdown && isLiveQuestion) {
                            Spacer(modifier = Modifier.height(8.dp))
                            Text(
                                text = if (isAnsweredThisQuestion) "" else countdownSeconds.toString(),
                                fontSize = 25.sp,
                                fontWeight = FontWeight.Bold,
                            )
                        }
                    }

                    Spacer(modifier = Modifier.height(8.dp))
                } // end measured Column

                Spacer(modifier = Modifier.height(navigationBarInset))
            } // end verticalScroll Column
        } // end BoxWithConstraints
    } // end outer Column
}

// ── Option color logic ────────────────────────────────────────────────────────

private fun buildOptionColors(
    displayState: QuestionDisplayState,
    answerFeedback: AnswerFeedbackState,
    isLiveQuestion: Boolean,
    green: Color,
    red: Color,
): List<Color> = (0..3).map { idx ->
    when {
        // Immediate feedback after answering the live question
        answerFeedback is AnswerFeedbackState.Showing && isLiveQuestion -> when (idx) {
            answerFeedback.correctIndex -> green
            answerFeedback.userIndex -> if (answerFeedback.userIndex != answerFeedback.correctIndex) red else green
            else -> Color.Transparent
        }
        // History / game-over view — stored answer data
        displayState.userAnswerIndex != -1 || !isLiveQuestion -> {
            val correctIdx = displayState.correctOptionIndex
            val userIdx = displayState.userAnswerIndex
            when (idx) {
                correctIdx -> green
                userIdx if userIdx != correctIdx -> red
                else -> Color.Transparent
            }
        }

        else -> Color.Transparent
    }
}

// ── Game-over parchment ───────────────────────────────────────────────────────

/**
 * Shows the end-of-game grade/message on the same parchment background,
 * with large primary-color text — mirroring the legacy questionTextView behavior.
 */
@Composable
private fun GameOverParchmentView(
    message: String,
    textColor: Color,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .wrapContentHeight(),
        contentAlignment = Alignment.Center,
    ) {
        androidx.compose.foundation.Image(
            painter = painterResource(SharedRes.images.parchment_verse),
            contentDescription = null,
            contentScale = androidx.compose.ui.layout.ContentScale.FillBounds,
            modifier = Modifier.matchParentSize(),
        )
        Text(
            text = message,
            textAlign = TextAlign.Center,
            fontSize = 40.sp,
            fontWeight = FontWeight.Bold,
            color = textColor,
            modifier = Modifier.padding(start = 36.dp, end = 42.dp, top = 24.dp, bottom = 32.dp),
        )
    }
}

// ── Game-over instruction buttons ─────────────────────────────────────────────

/**
 * The 4 instruction buttons shown at game over, matching the legacy
 * `announceEndOfTheGame()` layout:
 *  [0] invite to review
 *  [1] how to use the number row (gendered)
 *  [2] "where you were right"  — green background
 *  [3] "where you were wrong"  — red background
 */
@Composable
private fun GameOverInstructionButtons(
    hebrewGender: HebrewGender,
    green: Color,
    red: Color,
) {
    val texts = listOf(
        "רוצה לעבור שוב על השאלות והתשובות?",
        "[{לחץ/לחצי}] על המספרים למעלה ו[{בדוק/בדקי}]".personalizeGender(hebrewGender),
        "היכן צדקת",
        "והיכן טעית",
    )
    val letters = listOf("א", "ב", "ג", "ד")
    val feedbackColors = listOf(Color.Transparent, Color.Transparent, green, red)

    Column(modifier = Modifier.fillMaxWidth()) {
        texts.forEachIndexed { index, text ->
            AnswerButton(
                letter = letters[index],
                text = text,
                feedbackColor = feedbackColors[index],
                enabled = false,
                onClick = {},
            )
        }
    }
}

// ── Question numbers row ──────────────────────────────────────────────────────

@Composable
private fun QuestionNumbersRow(
    totalSlots: Int,
    availableCount: Int,
    currentQuestionIndex: Int,
    questionResults: ImmutableList<QuestionResult>,
    isGameOver: Boolean,
    onNumberClick: (Int) -> Unit,
    green: Color,
    red: Color,
    strokeColor: Color,
) {
    var reviewedIndex by rememberSaveable { mutableIntStateOf(-1) }
    LaunchedEffect(isGameOver) { if (!isGameOver) reviewedIndex = -1 }

    val disabledGray = Color.Gray

    CompositionLocalProvider(LocalLayoutDirection provides LayoutDirection.Ltr) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceEvenly,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            repeat(totalSlots) { index ->
                val questionExists = index < availableCount
                val isFuture = index > currentQuestionIndex
                // Enabled: question must exist AND (not future OR game over)
                val enabled = questionExists && (!isFuture || isGameOver)

                val result = questionResults.getOrNull(index)
                val backgroundColor = when {
                    !questionExists -> Color.Transparent
                    result == QuestionResult.Correct -> green
                    result == QuestionResult.Incorrect -> red
                    else -> Color.Transparent
                }
                val textColor = if (enabled) Color.Black else disabledGray
                val borderColor = if (enabled) strokeColor else disabledGray
                val isUnderlined = if (isGameOver) reviewedIndex == index else index == currentQuestionIndex

                QuestionNumberCircle(
                    number = index + 1,
                    enabled = enabled,
                    isUnderlined = isUnderlined,
                    backgroundColor = backgroundColor,
                    textColor = textColor,
                    borderColor = borderColor,
                    onClick = {
                        if (isGameOver && questionExists) {
                            onNumberClick(index)
                            reviewedIndex = index
                        }
                    },
                )
            }
        }
    }
}

@Composable
private fun RowScope.QuestionNumberCircle(
    number: Int,
    enabled: Boolean,
    isUnderlined: Boolean,
    backgroundColor: Color,
    textColor: Color,
    borderColor: Color,
    onClick: () -> Unit,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isPressed by interactionSource.collectIsPressedAsState()
    val highlight = colorResource(SharedRes.colors.highlight)
    val effectiveTextColor = if (isPressed && enabled) highlight else textColor

    Box(
        modifier = Modifier
            .weight(1f)
            // Square tiles would take a quarter of the height of a phone in landscape.
            .then(if (isShortWideWindow()) Modifier.height(40.dp) else Modifier.aspectRatio(1f))
            .border(1.dp, borderColor, RoundedCornerShape(16.dp))
            .background(backgroundColor, RoundedCornerShape(16.dp))
            .clickable(enabled = enabled, interactionSource = interactionSource, indication = null, onClick = onClick),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = number.toString(),
            color = effectiveTextColor,
            textAlign = TextAlign.Center,
            fontSize = 21.sp,
            textDecoration = if (isUnderlined) TextDecoration.Underline else TextDecoration.None,
        )
    }
}

// ── Answer button ─────────────────────────────────────────────────────────────

@Composable
private fun AnswerButton(
    letter: String,
    text: String,
    feedbackColor: Color,
    enabled: Boolean,
    onClick: () -> Unit,
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isPressed by interactionSource.collectIsPressedAsState()

    val backgroundColor = when {
        feedbackColor != Color.Transparent -> feedbackColor
        isPressed -> Color(0x80DAA000)
        else -> Color.Transparent
    }
    val disabledTextColor = Color(0xFF777777)

    val borderColor = when {
        !enabled && feedbackColor == Color.Transparent -> disabledTextColor
        isPressed -> colorResource(SharedRes.colors.strokeColor)
        else -> Color.Gray
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(bottom = 3.dp)
            .clip(RoundedCornerShape(10.dp))
            .border(1.dp, borderColor, RoundedCornerShape(10.dp))
            .background(backgroundColor)
            .clickable(enabled = enabled, interactionSource = interactionSource, indication = null, onClick = onClick)
            .padding(12.dp),
        contentAlignment = Alignment.Center,
    ) {
        Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            Text(
                text = letter,
                fontSize = 24.sp,
                color = if (enabled) Color(0xCC343434) else disabledTextColor,
                textAlign = TextAlign.Center,
            )
            Spacer(modifier = Modifier.weight(1f))
            Text(
                text = text.makeBoldByAsterisksAnnotated(),
                fontSize = 22.sp,
                textAlign = TextAlign.Center,
                color = if (enabled) Color.Unspecified else disabledTextColor,
                modifier = Modifier.weight(3f),
            )
            Spacer(modifier = Modifier.weight(1f))
        }
    }
}

// ── Styled button ─────────────────────────────────────────────────────────────

@Composable
private fun StyledButton(text: String, onClick: () -> Unit, modifier: Modifier = Modifier) {
    val shape = RoundedCornerShape(15.dp)
    Button(
        onClick = onClick,
        shape = shape,
        border = BorderStroke(1.dp, colorResource(SharedRes.colors.strokeColor)),
        colors = ButtonDefaults.buttonColors(
            containerColor = Color(0x003F51B5),
            contentColor = Color.White,
            disabledContainerColor = Color.Gray,
            disabledContentColor = Color.LightGray,
        ),
        modifier = modifier
            .wrapContentWidth()
            .background(
                brush = Brush.verticalGradient(
                    listOf(
                        colorResource(SharedRes.colors.colorPrimaryDark),
                        colorResource(SharedRes.colors.colorPrimary),
                    )
                ),
                shape = shape,
            )
            .padding(0.dp),
    ) {
        Text(text = text, fontSize = 26.sp, color = Color.White, modifier = Modifier.padding(4.dp))
    }
}

// ── Preview ───────────────────────────────────────────────────────────────────

// ── AmericanQuestionsContent previews ─────────────────────────────────────────

private fun previewQuestion(num: Int, question: String = "שאלה מספר $num — ______?") =
    com.eladfinish.bible.contest.screens.americanQuestions.model.AmericanQuestionItem(
        num = num,
        question = question,
        options = listOf("תשובה א", "תשובה ב", "תשובה ג", "תשובה ד"),
        correctOption = "תשובה א",
    )

private fun previewDisplayState(correctIndex: Int = 0, userAnswer: Int = -1) =
    QuestionDisplayState(
        shuffledOptions = persistentListOf("תשובה א", "תשובה ב", "תשובה ג", "תשובה ד"),
        correctOptionIndex = correctIndex,
        userAnswerIndex = userAnswer,
    )

private fun baseState() = AmericanQuestionsState(
    isSkipReadMeChecked = true,
    isLoading = false,
    dialogState = AmericanQuestionsState.DialogState.None,
    questions = (1..10).map { previewQuestion(it) }.toImmutableList(),
    hebrewGender = HebrewGender.MALE,
    numberOfQuestions = 10,
    numberOfQuestionsInFile = 10,
    remainingNumberOfQuestions = 8,
    enableCountdown = true,
)

@Preview(showBackground = true, name = "Active Game — Q3")
@Composable
private fun AmericanQuestionsContentActivePreview() {
    PreviewTheme {
        AmericanQuestionsContent(
            state = baseState().copy(
                currentQuestionIndex = 2,
                displayedQuestionIndex = 2,
                questionResults = persistentListOf(
                    QuestionResult.Correct,
                    QuestionResult.Incorrect,
                ),
                questionDisplayStates = persistentListOf(
                    previewDisplayState(correctIndex = 0, userAnswer = 0),
                    previewDisplayState(correctIndex = 1, userAnswer = 2),
                    previewDisplayState(correctIndex = 0),
                ),
                numberOfCorrectAnswers = 1,
                numberOfAskedQuestions = 2,
            ),
            hebrewGender = HebrewGender.MALE,
            onAnswer = {},
            onAdvance = {},
            onNewGame = {},
            onNumberClick = {},
            onQuestionLongClick = {},
        )
    }
}

@Preview(showBackground = true, name = "Active Game — Long Question")
@Composable
private fun AmericanQuestionsContentLongQuestionPreview() {
    PreviewTheme {
        AmericanQuestionsContent(
            state = baseState().copy(
                currentQuestionIndex = 0,
                displayedQuestionIndex = 0,
                questionDisplayStates = persistentListOf(
                    previewDisplayState(),
                ),
                questions = (listOf(
                    previewQuestion(
                        num = 1,
                        question = "... הִנֵּה אָנֹכִי חָטָאתִי וְאָנֹכִי הֶעֱוֵיתִי וְאֵלֶּה הַצּאֹן מֶה עָשׂוּ " +
                                "תְּהִי נָא יָדְךָ בִּי וּבְבֵית אָבִי מי אמר את הדברים?",
                    ),
                ) + (2..10).map { previewQuestion(it) }).toImmutableList(),
            ),
            hebrewGender = HebrewGender.MALE,
            onAnswer = {},
            onAdvance = {},
            onNewGame = {},
            onNumberClick = {},
            onQuestionLongClick = {},
        )
    }
}

@Preview(showBackground = true, name = "Game Over — Grade")
@Composable
private fun AmericanQuestionsContentGameOverPreview() {
    PreviewTheme {
        val results = persistentListOf(
            QuestionResult.Correct,
            QuestionResult.Incorrect,
            QuestionResult.Correct,
            QuestionResult.Correct,
            QuestionResult.Incorrect,
            QuestionResult.Correct,
            QuestionResult.Correct,
            QuestionResult.Incorrect,
            QuestionResult.Correct,
            QuestionResult.Correct,
        )
        AmericanQuestionsContent(
            state = baseState().copy(
                isGameOver = true,
                currentQuestionIndex = -1,
                displayedQuestionIndex = -1,
                questionResults = results,
                numberOfCorrectAnswers = 7,
                numberOfAskedQuestions = 10,
            ),
            hebrewGender = HebrewGender.FEMALE,
            onAnswer = {},
            onAdvance = {},
            onNewGame = {},
            onNumberClick = {},
            onQuestionLongClick = {},
        )
    }
}

@Preview(showBackground = true, name = "Game Over — History Review")
@Composable
private fun AmericanQuestionsContentHistoryReviewPreview() {
    PreviewTheme {
        AmericanQuestionsContent(
            state = baseState().copy(
                isGameOver = true,
                currentQuestionIndex = -1,
                displayedQuestionIndex = 1,
                questionResults = persistentListOf(
                    QuestionResult.Correct,
                    QuestionResult.Incorrect,
                ),
                questionDisplayStates = persistentListOf(
                    previewDisplayState(correctIndex = 0, userAnswer = 0),
                    previewDisplayState(correctIndex = 2, userAnswer = 0), // wrong: user picked 0, correct is 2
                ),
                numberOfCorrectAnswers = 1,
                numberOfAskedQuestions = 2,
            ),
            hebrewGender = HebrewGender.MALE,
            onAnswer = {},
            onAdvance = {},
            onNewGame = {},
            onNumberClick = {},
            onQuestionLongClick = {},
        )
    }
}
